import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Tab from '@/components/SingleView/Tab';
import Enable from '@/components/Common/Enable';
import Error from '@/components/SingleView/Error';
import Log from '@/components/SingleView/Log';
import AccidentManagement from '@/components/AccidentManagement';
import { SystemState } from '@/redux/type';
import { actionClearOperationList, actionSingTabType } from '@/redux/action';
import AccidentOrderAddModal from '@/components/AccidentOrderAddModal';
import RepairOrderAddModal from '@/components/RepairOrderAddModal';
import { SingleTabType, SingleViewRightTabConfig } from '@/utils/constant';
import './index.scss';

const TabCard = (props: {
  vehicleName: string;
  singleVehiclePageInfo: any;
  rightTab?: string;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [tabIdx, setTabIdx] = useState(0);
  const [accidentModelVisible, setAccidentModelVisible] = useState(false);
  const [repairModelVisible, setRepairModelVisible] = useState(false);
  const {
    vehicleRealTimeInfo,
    exceptionData,
    operationData,
    accidentList,
    vehicleBasicInfoNew,
  } = props.singleVehiclePageInfo;
  const { systemState, vehicleDrivableDirection } = vehicleRealTimeInfo;
  const { vehicleName, stationName, supplier } = vehicleBasicInfoNew;
  const errorList = exceptionData.list || [];
  const operationList = operationData.list || [];
  const enbaleLayout = {
    conBgSide: 316, // 底部圆圈背景的宽高,
    carWidth: 100, // 小车宽高
    carHeight: 190,
    obstacleWidth: 122, // 四周图表的宽高
    obstacleHeight: 59,
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('autoOpenRepairModal') === '1') {
      setRepairModelVisible(true);
      params.delete('autoOpenRepairModal');
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [location, navigate]);

  const tabChange = (tab: any) => {
    setTabIdx(tab.index);
    dispatch(actionSingTabType(tab.value));
    if (tab.index !== 2) {
      dispatch(actionClearOperationList());
    }
  };

  const handleClickAccidentAddBtn = () => {
    setAccidentModelVisible(true);
  };

  const handleClickRepairAddBtn = () => {
    setRepairModelVisible(true);
  };

  return (
    <>
      <div className="tabCard-con">
        <Tab
          tabChange={tabChange}
          hasBubble={accidentList?.length > 0}
          rightTab={props.rightTab}
        ></Tab>
        {tabIdx === SingleViewRightTabConfig[SingleTabType.DRIVABLE].index && (
          <div className="enable">
            <Enable
              disabled={
                systemState === SystemState.OFFLINE ||
                systemState === SystemState.CONNECTION_LOST
              }
              enable={vehicleDrivableDirection}
              enbaleLayout={enbaleLayout}
            ></Enable>
          </div>
        )}
        {tabIdx === SingleViewRightTabConfig[SingleTabType.ACCIDENT].index && (
          <AccidentManagement
            vehicleName={vehicleName}
            stationName={stationName}
            accidentList={accidentList}
            vehicleSupplier={supplier}
            handleClickAccidentAddBtn={handleClickAccidentAddBtn}
            handleClickRepairAddBtn={handleClickRepairAddBtn}
          />
        )}
        {tabIdx === SingleViewRightTabConfig[SingleTabType.EXCEPTION].index && (
          <Error errorList={errorList}></Error>
        )}
        {tabIdx === SingleViewRightTabConfig[SingleTabType.OPERATION].index && (
          <Log logList={operationList}></Log>
        )}
        {accidentModelVisible && (
          <AccidentOrderAddModal
            vehicleName={props.vehicleName}
            onCancel={() => setAccidentModelVisible(false)}
          />
        )}
        {repairModelVisible && (
          <RepairOrderAddModal
            vehicleName={props.vehicleName}
            onCancel={() => setRepairModelVisible(false)}
          />
        )}
      </div>
    </>
  );
};

export default React.memo(TabCard);
